// The terms and privacy versions an account has accepted. Each date is the Effective Date printed on its page
// (apps/web/src/pages/terms.astro, privacy.astro). A new date on either page means bumping it here, which asks
// every account to accept again.
export const TERMS_EFFECTIVE_DATE = '2026-11-04';
export const PRIVACY_EFFECTIVE_DATE = '2026-11-04';
export const CURRENT_TERMS_VERSION = `terms:${TERMS_EFFECTIVE_DATE};privacy:${PRIVACY_EFFECTIVE_DATE}`;
export function needsTermsAcceptance(termsVersion) {
    return termsVersion !== CURRENT_TERMS_VERSION;
}
//# sourceMappingURL=terms.js.map